export const ACCESS_TOKEN_NAME = 'access_token'
export const REFRESH_TOKEN_NAME = 'refresh_token'
export const AUTHORITIES_NAME = 'authorities'
export const USER_NAME = 'userName'
export const USER_FULL_NAME = 'fullName'
export const USER_ID = 'userId'
export const FILE_MAX_SIZE = 157286400 /* 150Mb */
export const FILE_MERGE_MAX_SIZE = 157286400 /* 150Mb */
// export const PLAYLIST_MAX_SIZE = 524288000 /* 500Mb */
export const PLAYLIST_MAX_SIZE = 209715200 /* 200Mb */
// export const PLAYLIST_MAX_SIZE = 20971520 /* 20Mb */
export const IS_CHECK_MAX_SIZE_UPLOAD = process.env.IS_CHECK_MAX_SIZE_UPLOAD
export const FULL_NAME = 'full_name'
export const TIME_OTP_EXPIRED = 'time_otp_exp'
export const IS_VERIFY_OTP_WITH_MAIL = process.env.IS_VERIFY_OTP_WITH_MAIL
export const STYLE_SHOW_DEVICE = process.env.STYLE_SHOW_DEVICE
export const RESET_PASSWORD_REQUIRED = 'reset_password_required'
export const ACCESS_TOKEN_EXPIRED = 'access_token_exp'
// export const CLIENT_ID = 'c91f6fc5ae02efa75456cf14260b0af2e983a09213915a6035b3b609c792ddad' //vinadigisign ttcs-cms
// export const CLIENT_ID = 'c91f6fc5ae02efa75456cf14260b0af2e983a09213915a6035b3b609c792ddad' //truyenthongsothongminh.vn
// export const CLIENT_ID = '85ba26613a29e6f0ed1419e400901c09e67d04cd530e4d1e88e3827cf4d4f8b3' //Bắc Kạn
// export const CLIENT_ID = '2472633e88891f9dfd500dd566d3eb365d25de05b55f9fa3c55aa89e11664d88' // Hoàng mai
export const CLIENT_ID = process.env.CLIENT_ID
export const CLIENT_ID_NAME = 'client-id'
export const IS_VERIFY_RECAPTCHA = false
export const PROVINCE_CODE = process.env.PROVINCE_CODE
export const PROVINCE_NAME = process.env.PROVINCE_NAME
export const HOTLINE = process.env.HOTLINE
// export const PROVINCE_CODE = '01'
// export const PROVINCE_NAME = 'TP Hà Nội'
export const REDIRECT_URI_NAME = 'redirect-uri'
export const CONFIG_AUTHORIZATION_CONNECT_PARTNER = process.env.CONFIG_AUTHORIZATION_CONNECT_PARTNER
export const LOCATION_CODE_NAME = 'location_code'
export const USER_POSITION = 'user_position'
export const NOTIFICATION_EMERGENCY = 'notification_emergency'

export const SUPPILER_ICON = process.env.SUPPILER_ICON
export const SUPPILER_NAME = process.env.SUPPILER_NAME
export const SUPPILER_ICON_FULL = process.env.SUPPILER_ICON_FULL

export const Authorities = {
  ROLE_ADMIN: 1,           /* Cấp trung ướng */
  ROLE_PROVINCE: 2,        /* Cấp tỉnh */
  ROLE_DISTRICT: 3,        /* Cấp huyện */
  ROLE_WARD: 4,            /* Cấp xã */
  ROLE_SYNCHRONIZE: 5,            /* Cấp đồng bộ */
  ROLE_VILLAGE: 6,  /* Cấp thôn */
  ROLE_MANAGEMENT: 7,  /* Quản lý */
  ROLE_MANAGEMENT_DEVICE: 8
}

export const FileType = {
  BIEN_TAP: 0,
  CHUYEN_DOI_VAN_BAN: 1,
  GHI_AM_TEP_TIN: 2,
  GHEP_TEP: 3,
}

export const ScreenHistoryType = {
  NHAN_BAN_TIN: 0, /* Nhận được bản tin */
  DA_PHAT: 1, /* Đã phát bản tin */
  DA_HUY: 3, /* Đã hủy bản tin */
  DANG_PHAT: 2, /* Đang phát bản tin */
  PHAT_LOI: 4 /* Phát lỗi bản tin */
}

export const ActionEditor = {
  LAYOUT_SETTING: 0,
  ADD_LAYER: 1,
  EDITOR_LAYER: 2,
  PREVIEW: 3,
}


export const TypeActionFileList = {
  DELETE_LIST: 1,
  RESTART_LIST: 2,
  UPDATE_APP_LIST: 3,
  STOP_BROADCASTING: 4,
  CHECK_TEMPERATURE: 5,
  GET_STATUS: 6,
}

export const HistoryTypeList = [
  {
    key: "null",
    value: "Tất cả trạng thái"
  },
  {
    key: "0",
    value: "Đang phát"
  },
  {
    key: "1",
    value: "Đã phát"
  },
  {
    key: "2",
    value: "Phát lỗi"
  }
]

export const ScheduleDetailStatus = {
  PENDING: 0,
  PLAYING: 1,
  BROADCAST: 2,
  ERROR: 3,
  CANCEL: 4,
  COINCIDENT: 5
}
